export default "__VITE_ASSET__8c0c0547__"